import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


import { useAuth } from '../context/AuthContext';

const HsHome = () => {
    const [type, setType] = useState(null);
    const [urlParam, setUrlParam] = useState(null);
    const [redirecting, setRedirecting] = useState(false);
    const {isInExtension} = useAuth();
    const { user } = useAuth();
    const navigate = useNavigate();

   console.log("isInExtension", isInExtension);


    useEffect(() => {
      if(!isInExtension){
        console.log("navigating to home", user);
        // If user needs onboarding (brand new user), send to onboarding step 1
        if(user.needsOnboarding){
          navigate('/tailspin/onboarding/step1');
        }
        // Otherwise, send to dashboard (tour will show if not onboarded yet)
        else {
          navigate('/tailspin/dashboard');
        }
    }else{
        const url = new URLSearchParams(window.location.search);
        const urlParamValue = url.get('url');
        console.log('urlParam', urlParamValue);
        
        if (urlParamValue) {
            setUrlParam(urlParamValue);
                extractFromUrl(urlParamValue);
            }
        }
    }, [isInExtension, navigate]);

    const extractFromUrl = (url) => {
        const dealMatch = url.match(/0-3\/(\d+)/);
        const companyMatch = url.match(/0-2\/(\d+)/);
        const contactMatch = url.match(/0-1\/(\d+)/);
        
        if (dealMatch) {
            setType('deal');
            setRedirecting(true);
            navigate('/deal-insights?url=' + url);
            console.log('full url', window.location.href);
            console.log('url', url);

        } else if (companyMatch) {
            setType('company');
            setRedirecting(true);
            navigate('/company-insights-test?url=' + url);
            console.log('full url', window.location.href);
            console.log('url', url);
        } else if (contactMatch) {
            setType('contact');
            // For now, route to company insights for contacts
            // navigate('/company-insights?url=' + url);
            setRedirecting(true);
            navigate('/company-insights-test?url=' + url);
        }

         if(url.includes("mail.google.com/mail/")){
            setType('gmail');
            setRedirecting(true);
            navigate('/company-insights-test');
         }



    };



    return (
        <div>
             <div style={{ 
          textAlign: 'center', 
          marginTop: 40,
          padding: '40px 20px',
          background: '#ffffff',
          borderRadius: 12,
          border: '1px solid #e5e7eb',
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
        }}>
          <div style={{ 
            fontSize: 48, 
            marginBottom: 16,
            color: '#6b7280'
          }}>
            📋
          </div>
          <h3 style={{ 
            color: '#1f2937', 
            fontSize: 20, 
            fontWeight: 600,
            marginBottom: 12
          }}>
            Currently Aura is available for HubSpot Deal Records and Company Records
          </h3>
          <p style={{ 
            color: '#6b7280', 
            fontSize: 15,
            lineHeight: 1.6,
            maxWidth: 500,
            margin: '0 auto',
            marginBottom: 20
          }}>
            
            Please navigate to a deal record to access our AI-powered insights, 
            next best actions, and personalized recommendations.
          </p>
          <div style={{ 
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            alignItems: 'center'
          }}>
            <div style={{ 
              padding: '12px 20px',
              background: '#f0f9ff',
              borderRadius: 8,
              border: '1px solid #0ea5e9',
              display: 'inline-block'
            }}>
              <span style={{ 
                color: '#0369a1', 
                fontSize: 12,
                fontWeight: 500
              }}>
                💡 Navigate to any deal drecord in HubSpot
              </span>
            </div>
            <div style={{ 
              padding: '8px 16px',
              background: '#f8fafc',
              borderRadius: 6,
              border: '1px solid #e2e8f0',
              fontSize: 13,
              color: '#64748b'
            }}>
              Support for other record types coming soon
            </div>
          </div>
        </div>
        </div>
    );
};

export default HsHome;